"use client";
import TopSheet from "@/components/ui/topSheet";
import React, { useCallback, useState } from "react";
import SearchBar from "./SearchBar";
import { debounce } from "@/utils/common";
import SuggestionList from "./SuggestionList";

export interface IProps {
  open: boolean;
  locale: string;
  lang: string;
  translation: Record<string, string>;
  onClose: () => void;
  enableVto: boolean;
}

const MobileSearchMenu = ({ open, lang, locale, translation, onClose, enableVto }: IProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useCallback(
    debounce((term: string) => {
      setSearchTerm(term);
    }, 300),
    [],
  );

  return (
    <TopSheet open={open} onClose={onClose}>
      <div className="flex h-full flex-col p-4">
        <div className={`flex items-center overflow-x-hidden transition-all duration-300`}>
          <SearchBar open={open} onClose={onClose} onChange={debouncedSearch} />
        </div>

        <div className="mt-2 flex-1 overflow-y-auto">
          <SuggestionList
            open={open}
            searchTerm={searchTerm}
            lang={lang}
            locale={locale}
            translation={translation}
            onClose={onClose}
            enableVto={enableVto}
          />
        </div>
      </div>
    </TopSheet>
  );
};

export default MobileSearchMenu;
